import { render } from "./NavbarItems.vue?vue&type=template&id=5d7b6918&scoped=true"
import script from "./NavbarItems.vue?vue&type=script&lang=js"
export * from "./NavbarItems.vue?vue&type=script&lang=js"

import "./NavbarItems.vue?vue&type=style&index=0&id=5d7b6918&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d7b6918"]])

export default __exports__